import { FieldLabel } from '@/ui/FieldLabel'
import { FieldRadioContent, FieldRadioGroup, FieldRadioSwatch } from '@/ui/FieldRadioGroup'
import Icon from '@/ui/Icon/Icon'
import { ModalContext, ModalTrigger } from '@/ui/Modal/Modalv2/Modal'

import { useProductTracking } from '../../ProductTracking/ProductTracking'
import { OptionFieldProps } from '../ProductConfigurator.types'
import { getBackgroundStyle, translatePriceModifier } from '@/domains/product/shared/product.utils'

export function PaperColorField({
  options,
  onChange,
  showInfo,
  priceModifier,
  onMouseEnter = () => {},
  isEnvelope = false,
}: OptionFieldProps) {
  const selected = options.find((option) => option.selected)

  const { track } = useProductTracking()

  if (!options.length) return null

  return (
    <ModalContext>
      <FieldRadioGroup defaultValue={selected?.valueId} data-testid="paper-color-field">
        <FieldLabel data-testid="paper-color-label">
          <FieldLabel.Title>Paper Color:</FieldLabel.Title>
          <FieldLabel.Text data-testid="label">{selected?.name}</FieldLabel.Text>
          {showInfo ? (
            <ModalTrigger asChild>
              <FieldLabel.Trigger
                onClick={() =>
                  track({
                    type: 'ctaClicked',
                    payload: { element_clicked: 'info modal icon', reason: 'Paper Color' },
                  })
                }
              >
                <Icon name="info" size="sm" />
              </FieldLabel.Trigger>
            </ModalTrigger>
          ) : null}
          {priceModifier ? <FieldLabel.Modifier>{translatePriceModifier(priceModifier)}</FieldLabel.Modifier> : null}
        </FieldLabel>
        {options.length > 1 ? (
          <FieldRadioContent radioType="swatches" overflow={true}>
            {options.map((option) => (
              <FieldRadioSwatch
                key={option.valueId}
                value={option.valueId}
                onClick={() => onChange(option.valueId)}
                onMouseEnter={() => onMouseEnter(option.valueId)}
                checked={option.selected}
                disabled={isEnvelope ? false : option.forbidden}
                style={getBackgroundStyle(option.background)}
              />
            ))}
          </FieldRadioContent>
        ) : null}
      </FieldRadioGroup>
    </ModalContext>
  )
}
